export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_9398_SCORECARD_SUMMARY': 'Scorecard Summary',
    '_9399_SEE_SCORECARD_DETAIL': 'See Scorecard Detail',
    '_9400_HIDE_SCORECARD_DETAIL': 'Hide Scorecard Detail',
    '_9401_SCORECARD_DETAIL': 'Scorecard Detail',
    '_711_NO_DATA_AVAILABLE': 'No Data Available',
    '_9308_ESTIMATED_PAYOUT': 'Estimated Payout',
    '_9253_TO': 'to',
    '_9402_NA': 'NA',
    '_9403_PREVIOUS_SCORECARD_NOT_AVAILABLE_FOR_COMPARE': 'Previous Scorecard not available for compare',
    '_9404_SCORE_TREND_': 'Score Trend:',
    '_9405_CURRENT_': 'Current:',
    '_9406_PREVIOUS_': 'Previous:',
    '_9407_SHOW_LESS': 'Show Less',
    '_9408_SHOW_MORE': 'Show More',
    '_102_USER_NAME': 'User Name',
    '_67_SUPERGROUP': 'SuperGroup',
    '_773_PERIOD': 'Period',
    '_962_OVERALL_SCORE': 'Overall Score',
    '_9293_PERIOD_TYPE': 'Period Type',
    '_9409_SEARCH_FOR_OTHER_USERS': 'Search for other users',
    '_9410_USER_': 'User:',
    '_804_SUPERGROUP_': 'SuperGroup:',
    '_9411_FROM': 'From',
    '_9412_SCORECARD_': 'Scorecard:',
    '_9880_MI2_SCORECARD_CATEGORY': 'MI2 Scorecard Category'
};
